.text-area {
  padding-top: 10px;
}
